angular.module('rightPaneModule')
  .controller('TeacherStudentsController', [
      '$timeout',
      '$scope',
      '$state',
      'edxReportItemService',
      'timeframe',
      'studentApi',
      'tableColumns',
      'tableSort',
      'authentication',
      'reportErrors',
      function (
          $timeout,
          $scope,
          $state,
          edxReportItemService,
          timeframe,
          $studentApi,
          $tableColumns,
          $tableSort,
          dblAuthentication,
          $reportErrors) {

      var updateMode = function() {
          $scope.listTableColumns = dblAuthentication.growthAsFraction()  ? $tableColumns.getColumns('student_fractions') : $tableColumns.getColumns('student');
          $scope.defaultMetric = dblAuthentication.growthAsFraction()  ? 'standards_growth' : 'percent_growth';

          $scope.activeMetric = $state.params.sort || $scope.listTableColumns[0];
      };

      $scope.years = {list: null, selected: {}};

      $scope.timeframes = {
          list: [
              {id: '0w', name: 'This Week', by: 'day', active: true},
              {id: '7d', name: 'Last 7 Days', by: 'day', active: false},
              {id: '30d', name: 'Last 30 Days', by: 'week', active: false}
          ],
          selected: {}
      };

      var updateFrequencyData = function () {
          $scope.frequencyError = null;
          $scope.frequencyData = undefined;
          $studentApi.getStudentsFrequency().then(function (data) {
              $scope.frequencyData = data;
          }, function(error) {
              $scope.frequencyError = $reportErrors.getErrorMessage(error);
          });
      };

      var updateStudents = function () {
          $scope.studentReportingForTeacherUrl = $studentApi.getStudentsReportingForTeacherExportUrl();

          $scope.tableError = null;
          $scope.listTableData = undefined;
          $studentApi.getStudentsReportingForTeacher().then(function (data) {
              $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, data);
              if (!$scope.listTableData) {
                  $scope.listTableData = [];
              }
          }, function(error) {
              $scope.listTableData = undefined;
              $scope.tableError = $reportErrors.getErrorMessage(error);
          });
      };

      var updateStudentsPaging = function (e, page) {
          $state.current.data.page = page;
          $scope.listTableData = undefined;
          $studentApi.getStudentsReportingForTeacher().then(function (data) {
              if (!$scope.listTableData) {
                  $scope.listTableData = [];
              }
              var uniqueList = _.uniq($scope.listTableData.concat(data), false, function (li) {
                  return li.id;
              });
              $scope.listTableData = uniqueList;
          });
      };

      var updateData = function () {
          updateMode();

          if (!$state.params.timeframe) {
              timeframe.updateStateParams($scope.timeframes.selected.id, $scope.timeframes.selected.by)
                .then(function () {
                    updateStudents();
                    updateFrequencyData();
                });
          } else {
              updateStudents();
              updateFrequencyData();
          }
      };

      var updateTableSort = function () {
          if ($scope.listTableData) {
              $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, $scope.listTableData);
          }
      };

      var initializeData = function (item) {
          $scope.item = item;

          $scope.$on('updateSortableTable', updateTableSort);

          $scope.$on('listTableNextPage', updateStudentsPaging);

          $scope.$on('listTableRowClicked', function (e, item) {
              $scope.$emit('route', item);
          });

          $scope.$on('yearSelected', updateData);

      };
      var itemSubscription = edxReportItemService.getCurrentItemObservable().subscribe(function (item) {
              initializeData(item);
          });

      var timeframeSubscription = timeframe.getYearListSubject().subscribe(function (years) {
          $scope.years.list = angular.copy(years);
      });

      $scope.$on('timeframeSelected', updateData);
      $scope.$on('timeframeInitialized', updateData);

      $scope.$on('$destroy', function () {
          itemSubscription.dispose();
          timeframeSubscription.dispose();
      });
  }]);
